import { render, staticRenderFns } from "./DriverSelect.vue?vue&type=template&id=0973556a&"
import script from "./DriverSelect.vue?vue&type=script&lang=js&"
export * from "./DriverSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports